<template>
  <SelectWithSearch
    label="Categoria"
    labelBusca="name"
    placeholder="Selecione uma categoria"
    :disabled="disabled"
    :change="change"
    :options="categoryCollection"
    :clearable="false"
    v-model="input"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options"> Selecione uma categoria </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectCategory',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      default: () => [1],
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setCategoryCollection(this.types);
    this.setDefaultCategory();
  },
  computed: {
    ...mapState('category', ['categoryCollection']),
  },
  methods: {
    ...mapActions('category', ['setCategoryCollection']),

    setDefaultCategory() {
      const category = this.categoryCollection.find((e) => e.isDefault);

      this.change(category);
    },
    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
